import { PERMISSIONS } from 'contexts/PermissionsContext';
import { SPEND_TYPE } from './constants';

export const getCurrencySymbolFromOptions = (options, currency) => {
	if (!options) {
		return currency ? currency.toUpperCase() : '';
	}

	if (!currency) {
		return '';
	}

	const currencyObj =
		options.find(item => item.code === currency.toLowerCase()) || {};

	return currencyObj.symbol || currency.toUpperCase();
};

export const INDUSTRY_OPTIONS = [
	{ id: 'aerospace-defense', label: 'Aerospace & Defense' },
	{ id: 'automotive-industrial', label: 'Automotive & Industrial' },
	{ id: 'consumer-products', label: 'Consumer Products' },
	{ id: 'energy-process-industries', label: 'Energy & Process Industries' },
	{ id: 'financial-services', label: 'Financial Services' },
	{ id: 'healthcare-life-sciences', label: 'Healthcare & Life Sciences' },
	{
		id: 'real-estate-engineering-constr',
		label: 'Real Estate, Engineering & Constr.',
	},
	{
		id: 'restaurants-hospitality-leisure',
		label: 'Restaurants, Hospitality, & Leisure',
	},
	{ id: 'retail', label: 'Retail' },
	{
		id: 'shipping-logistics-infrastructure',
		label: 'Shipping, Logistics, & Infrastructure',
	},
	{ id: 'technology-media-telecom', label: 'Technology, Media, & Telecom.' },
	{ id: 'other', label: 'Other' },
];

export const ENGAGEMENT_LEAD_OPTIONS = [
	{ id: 'engagement-lead-yes', label: 'Yes' },
	{ id: 'engagement-lead-no', label: 'No' },
];
export const NATURE_OF_ENGAGEMENT_OPTIONS = [
	{
		id: 'outside-in',
		label: 'Outside In',
		value: 'Outside In',
		name: 'natureOfEngagement',
	},
	{
		id: 'due-diligence',
		label: 'Due Diligence',
		value: 'Due Diligence',
		name: 'natureOfEngagement',
	},
	{
		id: 'quickstrike',
		label: 'QuickStrike',
		value: 'QuickStrike',
		name: 'natureOfEngagement',
	},
	{
		id: 'implementation',
		label: 'Implementation',
		value: 'Implementation',
		name: 'natureOfEngagement',
	},
	{
		id: 'other',
		label: 'Other',
		value: 'Other',
		name: 'natureOfEngagement',
	},
];

export const AREAS_COVERED_IN_PROJECT = [
	{ id: 'direct', label: 'Direct' },
	{ id: 'indirect', label: 'Indirect' },
	{ id: 'both', label: 'Both' },
];

export const PROCUREMENT_OPTIONS = [
	{ id: 'cfo', label: 'CFO' },
	{ id: 'coo', label: 'COO' },
	{ id: 'supply-chain', label: 'Supply Chain' },
	{ id: 'it', label: 'IT' },
	{ id: 'legal', label: 'Legal' },
	{ id: 'bu-decentralized', label: 'BU De-Centralized' },
	{ id: 'other', label: 'Other' },
];

export const PROCUREMENT_STRUTURE_OPTIONS = [
	{ id: 'centralized', label: 'Centralized' },
	{ id: 'decentralized', label: 'Decentralized' },
	{ id: 'center-led', label: 'Center-led' },
	{ id: 'other', label: 'Other' },
];

export const PTP_TOOL_OPTIONS = [
	{ id: 'ariba', label: 'Ariba' },
	{ id: 'coupa', label: 'Coupa' },
	{ id: 'jaggaer', label: 'Jaggaer' },
	{ id: 'oracle', label: 'Oracle' },
	{ id: 'gep-smart', label: 'GEP Smart' },
	{ id: 'basware', label: 'Basware' },
	{ id: 'ivalua', label: 'Ivalua' },
	{ id: 'trade-shift', label: 'TradeShift' },
	{ id: 'zycus', label: 'Zycus' },
	{ id: 'other', label: 'Other' },
];

export const SPEND_ANALYTICS_TOOL_OPTIONS = [
	{ id: 'coupa', label: 'Coupa' },
	{ id: 'ariba', label: 'Ariba' },
	{ id: 'oracle', label: 'Oracle' },
	{ id: 'jaggaer', label: 'Jaggaer' },
	{ id: 'gep-smart', label: 'GEP Smart' },
	{ id: 'ivalua', label: 'Ivalua' },
	{ id: 'emptoris', label: 'Emptoris' },
	{ id: 'zycus', label: 'Zycus' },
	{ id: 'bravo', label: 'Bravo' },
	{ id: 'sievo', label: 'Sievo' },
	{ id: 'other', label: 'Other' },
];

export const CLM_TOOL_OPTIONS = [
	{ id: 'icertis', label: 'Icertis' },
	{ id: 'docu-sign', label: 'Docu-Sign' },
	{ id: 'ariba', label: 'Ariba' },
	{ id: 'coupa', label: 'Coupa' },
	{ id: 'oracle', label: 'Oracle' },
	{ id: 'conga', label: 'Conga' },
	{ id: 'agiloft', label: 'Agiloft' },
	{ id: 'apttus', label: 'Apttus' },
	{
		id: 'contractworks',
		label: 'ContractWorks',
	},
	{ id: 'other', label: 'Other' },
];
export const AI_OPTIONS = [
	{ id: 'none', label: 'None' },
	{ id: 'planning', label: 'Planning' },
	{ id: 'testing/deploying', label: 'Testing/Deploying' },
	{ id: 'piloted', label: 'Piloted' },
	{ id: 'activelyDeployed', label: 'Actively Deployed (Multiple Solutions)' },
];

export const QMS_OPTIONS = [
	{ id: 'yes', label: 'Yes' },
	{ id: 'no', label: 'No' },
];
export const REGION_OPTIONS = [
	{
		name: 'regionsSurveyApplicableFor',
		value: 'North America',
		label: 'North America',
		id: 'north-america',
	},
	{
		name: 'regionsSurveyApplicableFor',
		value: 'EMEA',
		label: 'EMEA',
		id: 'emea',
	},
	{
		name: 'regionsSurveyApplicableFor',
		value: 'APAC',
		label: 'APAC',
		id: 'apac',
	},
	{
		name: 'regionsSurveyApplicableFor',
		value: 'LATAM',
		label: 'LATAM',
		id: 'latam',
	},
];

export const DEFAULT_FORM = {
	yourName: '', // For input type="text"
	clientName: '', // For input type="text"
	industry: [], // For radio buttons
	clientGlobalRevenue: '', // For input type="number"
	regionsSurveyApplicableFor: [], // For checkboxes
	natureOfEngagement: [], // For radio buttons
	areasCoveredInProject: [], // For radio buttons
	projectStartDate: '', // For input type="date"
	directTotalStrategicSourcingFTEs: '', // For input type="number"
	indirectTotalStrategicSourcingFTEs: '', // For input type="number"
	directTotalBuyersOperationalProcurementFTEs: '', // For input type="number"
	indirectTotalBuyersOperationalProcurementFTEs: '', // For input type="number"
	buyersOperationalProcurementFTEsInBestCostCountry: '', // For input type="number"
	procurementFunction: [], // For radio buttons and other option answer
	procurementStructure: [], // For radio buttons and other option answer
	directMaterialsPreviousSavingsTarget: '', // For input type="text"
	indirectMaterialsPreviousSavingsTarget: '', // For input type="text"
	portionOfIndirectSpendUnderManagement: '', // For input type="text"
	averagePaymentTermsDirectMaterials: '', // For input type="number"
	averagePaymentTermsIndirectMaterials: '', // For input type="number"
	approximatePOsProcessedAnnuallyDirect: '', // For input type="number"
	approximatePOsProcessedAnnuallyIndirect: '', // For input type="number"
	portionOfIndirectSpendPOBacked: '', // For input type="text"
	portionOfIndirectPurchaseOrders: '', // For input type="number"
	portionOfDirectPurchaseOrders: '', // For input type="number"
	ptpTool: [], // The selected PTP tool
	clmTool: [], // The selected CLM tool
	spendAnalyticsTool: [], // The selected spendAnalyticsTool tool
	aiValue: [],
};

export const countFilledFields = form => {
	return Object.keys(form).reduce((count, key) => {
		const value = form[key];
		// Count non-empty values (check if string is not empty or if array has elements)
		if (value !== '' && !(Array.isArray(value) && value.length === 0)) {
			return count + 1;
		}
		return count;
	}, 0);
};

export const ROOT_ROUTE = '/data/vendor-cleanup';
export const VENDOR_NORMALIZATION_SPEND_TYPE = [
	{
		path: `${ROOT_ROUTE}/indirect`,
		name: SPEND_TYPE.INDIRECT,
		label: 'Indirect spend',
		required: PERMISSIONS.RawDataWrite,
	},
	{
		path: `${ROOT_ROUTE}/direct`,
		name: SPEND_TYPE.DIRECT,
		label: 'Direct spend',
		required: PERMISSIONS.RawDataWrite,
	},
];

export const VENDOR_EDIT_ROOT_ROUTE = '/data/vendor-edit';
export const VENDOR_EDIT_SPEND_TYPE = [
	{
		path: `${VENDOR_EDIT_ROOT_ROUTE}/indirect`,
		name: SPEND_TYPE.INDIRECT,
		label: 'Indirect spend',
		required: PERMISSIONS.RawDataWrite,
	},
	{
		path: `${VENDOR_EDIT_ROOT_ROUTE}/direct`,
		name: SPEND_TYPE.DIRECT,
		label: 'Direct spend',
		required: PERMISSIONS.RawDataWrite,
	},
];
